import axios from 'axios'
import store from '@/store'
import Cookies from 'js-cookie'
import userRules from '@/api/userRules'
async function selectCompany(cnpj, profile) {

    try {
        const result = await axios.post(`${process.env.VUE_APP_ROOT_API}/clients/v1/users/signin`, {
            token: store.state.user.token,
            cnpj,
            companyType: profile,
        }, )

        store.commit('user/setToken', result.data.payload)

        store.commit('user/setProfile', profile)

        Cookies.set('token', result.data.payload, { expires: 1, domain: process.env.VUE_APP_ROOT_DOMAIN })

        Cookies.set('selectedCompany', { cnpj, companyType: profile }, { expires: 1, domain: process.env.VUE_APP_ROOT_DOMAIN })

        Cookies.set('selectedProfile', profile, { expires: 1, domain: process.env.VUE_APP_ROOT_DOMAIN })

        await userRules()

        return result
    } catch (error) {
        console.log(error)
        const result = { data: { ok: false } }
        return result
    }

}

export default selectCompany